// BDS CUSTOM: Breast Cancer Awareness Tumbler picker.
// 2026-08-22 restructure: product is now a SINGLE per-tumbler variant
// (48310749167805, $25) with automatic volume discounts. Pack sizes
// (6/12/48) are UI presets that dictate quantity, not variants.
//
// Behavior:
//   TOTAL = packSize × numberOfPacks
//   ATC posts one tumbler line { id: variantId, quantity: TOTAL }
//   Automatic discounts price it (12+ = $23.75, 48+ = $21.25).
//   Personalization on → also add fee variant with quantity = TOTAL and
//   attach Dealer/Business Name + Phone as properties on the tumbler line.
//
// Progressive phone formatter mirrors bdsBcaFormatPhoneProgressive() in
// assets/bca-size-matrix.js — copied here to keep the file self-contained.

(function () {
  'use strict';

  // Per-tumbler tier price (cents) from the automatic-discount schedule.
  function tierCentsForTotal(total) {
    if (total >= 48) return 2125;
    if (total >= 12) return 2375;
    return 2500;
  }

  function bdsTumblerFormatPhoneProgressive(raw) {
    var digits = String(raw || '').replace(/\D/g, '').slice(0, 10);
    if (digits.length === 0) return '';
    if (digits.length < 4)   return '(' + digits;
    if (digits.length < 7)   return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('bds-tumbler-form');
    if (!form) return;

    var packs        = form.querySelectorAll('[data-bds-pack]');
    var packRadios   = form.querySelectorAll('input[name="bds-tumbler-pack"]');
    var qtyInput     = document.getElementById('bds-tumbler-qty');
    var minusBtn     = document.getElementById('bds-tumbler-minus');
    var plusBtn      = document.getElementById('bds-tumbler-plus');
    var persoToggle  = document.getElementById('bds-tumbler-perso-toggle');
    var persoFields  = document.getElementById('bds-tumbler-perso-fields');
    var nameInput    = document.getElementById('bds-tumbler-dealer-name');
    var phoneInput   = document.getElementById('bds-tumbler-dealer-phone');
    var persoError   = document.getElementById('bds-tumbler-perso-error');
    var atcBtn       = document.getElementById('bds-tumbler-atc-btn');
    var errorEl      = document.getElementById('bds-tumbler-error');

    var variantId    = parseInt(form.dataset.variantId, 10);
    var feeVariantId = parseInt(form.dataset.feeVariantId, 10);
    var feeCents     = parseInt(form.dataset.feeCents, 10) || 400;

    var summaryLabel  = form.querySelector('[data-bds-tumbler-line-label]');
    var summaryDetail = form.querySelector('[data-bds-tumbler-line-detail]');
    var summaryFeeRow = form.querySelector('[data-bds-tumbler-fee-row]');
    var summaryFeeDet = form.querySelector('[data-bds-tumbler-fee-detail]');
    var summaryTotal  = form.querySelector('[data-bds-tumbler-total]');
    var USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    function fmt(cents) { return USD.format(cents / 100); }

    // ── Pack selection (UI-only; drives packSize, not variant id) ────────────
    function selectPack(packSize) {
      packs.forEach(function (p) {
        var match = String(p.dataset.packSize) === String(packSize);
        p.classList.toggle('bds-tumbler-pack--selected', match);
        var radio = p.querySelector('input[type="radio"]');
        if (radio) radio.checked = match;
      });
      renderAddingSummary();
    }
    function selectedPackSize() {
      var radio = form.querySelector('input[name="bds-tumbler-pack"]:checked');
      var n = radio ? parseInt(radio.dataset.packSize || radio.value, 10) : NaN;
      return (!n || n < 1) ? 6 : n;
    }
    packRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) selectPack(parseInt(radio.dataset.packSize || radio.value, 10));
      });
    });

    // ── Pack qty stepper ─────────────────────────────────────────────────────
    function currentQty() {
      var n = parseInt(qtyInput.value, 10);
      if (!n || n < 1) return 1;
      return n;
    }
    function setQty(n) {
      qtyInput.value = String(Math.max(1, n));
      minusBtn.disabled = currentQty() <= 1;
      renderAddingSummary();
    }
    minusBtn.addEventListener('click', function () { setQty(currentQty() - 1); });
    plusBtn .addEventListener('click', function () { setQty(currentQty() + 1); });
    qtyInput.addEventListener('input', function () { minusBtn.disabled = currentQty() <= 1; renderAddingSummary(); });
    qtyInput.addEventListener('blur',  function () { setQty(currentQty()); });

    // ── Personalization toggle ───────────────────────────────────────────────
    function isPerso() { return persoToggle.checked; }
    function setPersoVisibility() {
      var on = isPerso();
      persoFields.style.display = on ? 'block' : 'none';
      [nameInput, phoneInput].forEach(function (el) { if (el) el.disabled = !on; });
      if (!on && persoError) persoError.hidden = true;
      renderAddingSummary();
    }
    persoToggle.addEventListener('change', setPersoVisibility);
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        if (persoError && nameInput.value.trim().length > 0) persoError.hidden = true;
      });
    }
    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var caretAtEnd = phoneInput.selectionStart === phoneInput.value.length;
        var formatted  = bdsTumblerFormatPhoneProgressive(phoneInput.value);
        if (formatted !== phoneInput.value) {
          phoneInput.value = formatted;
          if (caretAtEnd) phoneInput.setSelectionRange(formatted.length, formatted.length);
        }
      });
    }

    // ── Adding-to-Cart summary (TOTAL-based tier price) ──────────────────────
    function renderAddingSummary() {
      if (!summaryLabel || !summaryDetail || !summaryTotal) return;
      var total     = selectedPackSize() * currentQty();
      var unitCents = tierCentsForTotal(total);
      var lineCents = unitCents * total;

      summaryLabel.textContent  = 'Tumblers';
      summaryDetail.textContent = total + ' × ' + fmt(unitCents) + ' = ' + fmt(lineCents);

      var totalCents = lineCents;
      if (isPerso()) {
        var feeTotal = total * feeCents;
        totalCents  += feeTotal;
        if (summaryFeeRow) summaryFeeRow.hidden = false;
        if (summaryFeeDet) summaryFeeDet.textContent = total + ' × ' + fmt(feeCents) + ' = ' + fmt(feeTotal);
      } else if (summaryFeeRow) {
        summaryFeeRow.hidden = true;
      }
      summaryTotal.textContent = fmt(totalCents);
    }

    // ── Submit guard ─────────────────────────────────────────────────────────
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isPerso()) {
        if (!nameInput || nameInput.value.trim().length === 0) {
          if (persoError) persoError.hidden = false;
          if (nameInput)  nameInput.focus();
          return;
        }
      }
      doAtc();
    }, true);

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
    }

    function doAtc() {
      if (atcBtn.disabled) return;
      if (!variantId) {
        showError('Tumbler variant is unavailable. Please refresh and try again.');
        return;
      }

      var total = selectedPackSize() * currentQty();

      var properties = null;
      if (isPerso()) {
        properties = { 'Dealer / Business Name': nameInput.value.trim() };
        if (phoneInput && phoneInput.value.trim()) properties['Phone Number'] = phoneInput.value.trim();
      }

      var items = [];
      var tumblerLine = { id: variantId, quantity: total };
      if (properties) tumblerLine.properties = properties;
      items.push(tumblerLine);

      if (isPerso() && feeVariantId) {
        items.push({ id: feeVariantId, quantity: total });
      }

      var originalText = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';
      errorEl.style.display = 'none';

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = {
        items: items,
        sections:     cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'],
        sections_url: window.location.pathname
      };

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(body)
      })
        .then(async function (res) {
          if (!res.ok) {
            var e = await res.json().catch(function () { return {}; });
            throw new Error(e.description || 'Could not add to cart.');
          }
          var responseData = await res.json();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bds-tumbler', cartData: responseData });
          }
          if (cart) {
            cart.renderContents(responseData);
          } else {
            var newBubbleHTML = responseData.sections && responseData.sections['cart-icon-bubble'];
            var liveBubble = document.getElementById('cart-icon-bubble');
            if (newBubbleHTML && liveBubble) {
              var parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
              var inner = parsed.querySelector('.shopify-section');
              if (inner) liveBubble.innerHTML = inner.innerHTML;
            }
          }
          atcBtn.disabled = false;
          atcBtn.textContent = originalText;
        })
        .catch(function (err) {
          atcBtn.disabled = false;
          atcBtn.textContent = originalText;
          showError(err.message || 'Something went wrong. Please try again.');
        });
    }

    // ── Initial state ────────────────────────────────────────────────────────
    setQty(currentQty());
    setPersoVisibility();
    renderAddingSummary();
  });
})();
